import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["src", "title"];
const _hoisted_2 = {
  key: 1,
  class: "fallback-icon"
};
const _hoisted_3 = {
  class: "img-frame"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "name single-line-text"
};
const _hoisted_7 = {
  class: "season"
};
import { useCinemaName, usePlayRecordNFO } from '@shared/composable/cinema';
import { computed, ref } from 'vue';
import { openPopCinemaDetail } from '@remote/utils/dialog';
import { useDeviceStore } from '@remote/store/device';
import debounce from 'lodash/debounce';
import fallbackIcon from '@shared/assets/img/cinema-fallback-icon.png';
import { stat } from '@remote/utils/stat';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaRecentPlayItem',
  props: {
    nfo: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const colorScheme = ref(Math.floor(Math.random() * 5));
    const {
      getNFOName
    } = useCinemaName();
    const deviceStore = useDeviceStore();
    const nfo = computed(() => props.nfo);
    const {
      lastPlayEpisode,
      progress
    } = usePlayRecordNFO(nfo);
    const isPosterShow = computed(() => {
      var _deviceStore$currentD;
      return (_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 || (_deviceStore$currentD = _deviceStore$currentD.nfoInstance) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.isPosterShow;
    });
    const nfoName = computed(() => {
      var _props$nfo$scrape_res;
      if (((_props$nfo$scrape_res = props.nfo.scrape_result) === null || _props$nfo$scrape_res === void 0 ? void 0 : _props$nfo$scrape_res.class) === 'tv' && lastPlayEpisode.value) {
        return [getNFOName(props.nfo), lastPlayEpisode.value].join('·').trim();
      }
      return getNFOName(props.nfo);
    });
    const nfoYear = computed(() => {
      var _props$nfo$scrape_res2, _props$nfo$scrape_res7;
      if (((_props$nfo$scrape_res2 = props.nfo.scrape_result) === null || _props$nfo$scrape_res2 === void 0 ? void 0 : _props$nfo$scrape_res2.class) === 'tv') {
        var _props$nfo$scrape_res3, _props$nfo$scrape_res5;
        // 电视剧
        if (props.nfo.scrape_result.season && (_props$nfo$scrape_res3 = props.nfo.scrape_result.dramas) !== null && _props$nfo$scrape_res3 !== void 0 && _props$nfo$scrape_res3.length) {
          var _props$nfo$scrape_res4;
          // 有季和集信息
          return `${props.nfo.scrape_result.year} | 第${props.nfo.scrape_result.season}季·共${(_props$nfo$scrape_res4 = props.nfo.scrape_result.dramas) === null || _props$nfo$scrape_res4 === void 0 ? void 0 : _props$nfo$scrape_res4.length}集`;
        }
        if ((_props$nfo$scrape_res5 = props.nfo.scrape_result.dramas) !== null && _props$nfo$scrape_res5 !== void 0 && _props$nfo$scrape_res5.length) {
          var _props$nfo$scrape_res6;
          return `${props.nfo.scrape_result.year} | 共${(_props$nfo$scrape_res6 = props.nfo.scrape_result.dramas) === null || _props$nfo$scrape_res6 === void 0 ? void 0 : _props$nfo$scrape_res6.length}集`;
        }
        return `${props.nfo.scrape_result.year}`;
      }
      return `${(_props$nfo$scrape_res7 = props.nfo.scrape_result) === null || _props$nfo$scrape_res7 === void 0 ? void 0 : _props$nfo$scrape_res7.year}`;
    });
    const handleClick = debounce(async () => {
      var _props$nfo$video_info, _ref, _Number, _scrapeResult$dramas;
      const scrapeResult = props.nfo.scrape_result;
      stat({
        action: 'cinema_video_card_click',
        data: {
          home_module: 'recently_played',
          scraper_name: scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.trans_name,
          origin_name: (_props$nfo$video_info = props.nfo.video_info) === null || _props$nfo$video_info === void 0 ? void 0 : _props$nfo$video_info.file_name,
          scraper_type: scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.class,
          episode_num: (_ref = (_Number = Number(scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.episode_nums)) !== null && _Number !== void 0 ? _Number : scrapeResult === null || scrapeResult === void 0 || (_scrapeResult$dramas = scrapeResult.dramas) === null || _scrapeResult$dramas === void 0 ? void 0 : _scrapeResult$dramas.length) !== null && _ref !== void 0 ? _ref : 1
        }
      });
      openPopCinemaDetail({
        nfo: props.nfo,
        from: 'home_recently_played'
      });
    }, 500, {
      leading: true,
      trailing: false
    });
    return (_ctx, _cache) => {
      var _nfo$value$scrape_res, _nfo$value$scrape_res2, _nfo$value$scrape_res3, _nfo$value$scrape_res4, _nfo$value$scrape_res5;
      return _openBlock(), _createElementBlock("li", {
        class: "record",
        key: (_nfo$value$scrape_res = nfo.value.scrape_result) === null || _nfo$value$scrape_res === void 0 ? void 0 : _nfo$value$scrape_res.id,
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(handleClick) && _unref(handleClick)(...args))
      }, [_createElementVNode("div", {
        class: _normalizeClass(['img-wrap', `scheme-${colorScheme.value}`])
      }, [isPosterShow.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: (_nfo$value$scrape_res2 = (_nfo$value$scrape_res3 = nfo.value.scrape_result) === null || _nfo$value$scrape_res3 === void 0 ? void 0 : _nfo$value$scrape_res3.poster_horizontal) !== null && _nfo$value$scrape_res2 !== void 0 ? _nfo$value$scrape_res2 : (_nfo$value$scrape_res4 = nfo.value.scrape_result) === null || _nfo$value$scrape_res4 === void 0 ? void 0 : _nfo$value$scrape_res4.poster_vertical,
        title: (_nfo$value$scrape_res5 = nfo.value.scrape_result) === null || _nfo$value$scrape_res5 === void 0 ? void 0 : _nfo$value$scrape_res5.trans_name,
        draggable: "false"
      }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(fallbackIcon),
        draggable: "false"
      }, null, 8, _hoisted_4)])])), _createElementVNode("div", {
        class: "progress",
        style: _normalizeStyle({
          width: `${_unref(progress)}%`
        })
      }, null, 4)], 2), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(nfoName.value), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(nfoYear.value), 1)])]);
    };
  }
});